import {
    Card, CardHeader, CardContent,
    Checkbox, FormControlLabel, Stack, Typography
  } from "@mui/material";
  import { useAppSelector, useAppDispatch } from '../../../redux-store/hooks';
  import { useState } from 'react';
  import { updateClientInfo } from '../../../services';
  import { BottomSaveBar, ClientTaxList } from '../components';
  
  const ClientTaxSettings = () => {
    const clientInfo = useAppSelector(state => state.clientInfo.data);
    const dispatcher = useAppDispatch();
    const [tmanager, setTmanager] = useState(clientInfo.taxManager);
  
    const updateTaxSettings = async () => {
      const tempClient = { ...clientInfo };
      tempClient.taxManager = {
        ...tempClient.taxManager,
        isTaxApplicable: tmanager.isTaxApplicable,
        applyDefaultTax: tmanager.applyDefaultTax,
        considerStrictProductSettings: tmanager.considerStrictProductSettings
      };
      await dispatcher(updateClientInfo({ clientId: tempClient._id || "", body: tempClient }));
    };
  
    return (
      <Stack p={2}>
        <Card >
          <CardHeader title="Global Tax Options" />
          <CardContent>
            <FormControlLabel
              control={
                <Checkbox
                  checked={tmanager.isTaxApplicable}
                  onChange={(e) => setTmanager({ ...tmanager, isTaxApplicable: e.target.checked })}
                />
              }
              label="Is Tax Applicable"
            />
            <Stack ml={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={tmanager.applyDefaultTax}
                    onChange={(e) => setTmanager({ ...tmanager, applyDefaultTax: e.target.checked })}
                  />
                }
                disabled={!tmanager.isTaxApplicable}
                label="Apply Default Tax"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={tmanager.considerStrictProductSettings}
                    onChange={(e) => setTmanager({ ...tmanager, considerStrictProductSettings: e.target.checked })}
                  />
                }
                disabled={!tmanager.isTaxApplicable}
                label={
                  <Typography>
                    Enforce Strict Product Tax<br />
                    <small>Overrides global tax with product-specific settings</small>
                  </Typography>
                }
              />
            </Stack>
          </CardContent>
        </Card>
  
        <ClientTaxList />
        <BottomSaveBar onSave={updateTaxSettings} />
      </Stack>
    );
  };
  
  export { ClientTaxSettings };
  